import Link from "next/link";
import SectionHeader from "@/components/SectionHeader";

export default function CitiesList({
  cities,
  title = "Fotobox mieten in weiteren Städten",
  subtitle = "Finde passende Fotoboxen auch in anderen Regionen Deutschlands.",
}) {
  const defaultCities = [
    { name: "Berlin", href: "/fotobox-mieten-berlin" },
    { name: "Hamburg", href: "/fotobox-mieten-hamburg" },
    { name: "München", href: "/fotobox-mieten-muenchen" },
    { name: "Köln", href: "/fotobox-mieten-koeln" },
    { name: "Frankfurt am Main", href: "/fotobox-mieten-frankfurt-am-main" },
    { name: "Stuttgart", href: "/fotobox-mieten-stuttgart" },
    { name: "Düsseldorf", href: "/fotobox-mieten-duesseldorf" },
    { name: "Leipzig", href: "/fotobox-mieten-leipzig" },
    { name: "Dortmund", href: "/fotobox-mieten-dortmund" },
    { name: "Essen", href: "/fotobox-mieten-essen" },
    { name: "Bremen", href: "/fotobox-mieten-bremen" },
    { name: "Dresden", href: "/fotobox-mieten-dresden" },
    { name: "Hannover", href: "/fotobox-mieten-hannover" },
    { name: "Nürnberg", href: "/fotobox-mieten-nuernberg" },
    { name: "Duisburg", href: "/fotobox-mieten-duisburg" },
  ];

  const cityList = cities?.length ? cities : defaultCities;

  return (
    <SectionHeader title={title} subtitle={subtitle}>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        {cityList.map((city) => (
          <Link
            key={city.name}
            href={city.href}
            className="rounded-full bg-white px-4 py-2 text-sm font-semibold text-slate-700 ring-1 ring-slate-200/80 shadow-sm transition hover:shadow-md hover:text-slate-900"
          >
            {city.name}
          </Link>
        ))}
      </div>
    </SectionHeader>
  );
}
